<mat-form-field class="w-100">
  <mat-label>Search Commodity</mat-label>
  <input matInput [formControl]="searchControl">
  @if (searchActive$ | async) {
    <app-icon matIconSuffix class="mr-2" icon="spinner" [spin]="true"></app-icon>
  }
</mat-form-field>
<mat-action-list>
  <button mat-list-item (click)="newCommodity()" i18n>Add Empty Commodity</button>
  @for (com of filteredCommodities$ | async; track com) {
    <button mat-list-item (click)="selectCommodity(com)">
      <div class="flex flex-row w-full justify-between gap-2">
        <app-icon icon="package-library"></app-icon>
        <span>{{ com.description }}</span>
        <span class="flex flex-grow"></span>
        <span class="text-gray-500 small">{{ com.harmonizedCode }}</span>
        <span>{{ com.country }}</span>
        <span>{{ com.markings }}</span>
        <span>{{ com.price | money:com.currency }}</span>
      </div>
    </button>
  }
</mat-action-list>